import { Link } from 'react-router-dom';
import type { BlogPostMetadata } from '../data/types';
import { trackTagClick } from '../utils/analytics';
import styles from '../styles/BlogPostCard.module.css';

interface BlogPostCardProps {
    post: BlogPostMetadata;
}

function BlogPostCard({ post }: BlogPostCardProps) {
    const handleTagClick = (tag: string) => {
        trackTagClick(tag, 'blog_card');
    };

    return (
        <article className={styles.card}>
            <Link to={`/blog/${post.slug}`} className={styles.link}>
                <h2>{post.title}</h2>
                <time dateTime={post.date}>{new Date(post.date).toLocaleDateString()}</time>
                <p>{post.description}</p>
            </Link>
            {post.tags && post.tags.length > 0 && (
                <div className={styles.tags}>
                    {post.tags.map((tag) => (
                        <Link
                            key={tag}
                            to={`/blog/tag/${encodeURIComponent(tag)}`}
                            className={styles.tag}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleTagClick(tag);
                            }}
                        >
                            {tag}
                        </Link>
                    ))}
                </div>
            )}
        </article>
    );
}

export default BlogPostCard;
